module.exports = __webpack_public_path__ + "media/assets/logo/Logo_SemFundo_semNome_Agrosim_branco-d12559fe375e74491b9d8b12f0525a93.png";